import { useMemo } from 'react';
import { useData } from './DataProvider';
import { APIClient } from '../helpers/api_helper';

export function useApi() {
  const { time } = useData();
  return useMemo(
    () => new APIClient(process.env.REACT_APP_API_URL || time?.apiPath || ''),
    [time]
  );
}
